// src/pages/admin/adminPageEditor/components/EditorHeader.jsx
import React from "react";

export default function EditorHeader({
  pageName,
  previewSlug,
  isEditorTab,
  onBack,
  onOpen,
  onPreview,
  onSave,
  saving,
}) {
  return (
    <div className="sticky top-0 z-40 bg-white border-b">
      <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <button onClick={onBack} className="px-3 py-2 rounded-lg border hover:bg-gray-50 shrink-0">
            Back
          </button>

          <div className="min-w-0">
            <div className="text-lg font-bold text-gray-900 truncate">
              {pageName || "Untitled"}
            </div>
            <div className="text-sm text-gray-500 truncate">/{previewSlug}</div>
          </div>
        </div>

        <div className="flex items-center gap-2 sm:gap-3 shrink-0">
          <button onClick={onOpen} className="px-3 sm:px-4 py-2 rounded-lg border hover:bg-gray-50">
            Open
          </button>

          {isEditorTab && (
            <button onClick={onPreview} className="px-3 sm:px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700">
              Preview
            </button>
          )}

          <button
            onClick={onSave}
            disabled={saving}
            className="px-3 sm:px-4 py-2 rounded-lg bg-green-600 text-white hover:bg-green-700 disabled:opacity-50"
          >
            {saving ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}